"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDelayparams = void 0;
/**
 * 行情延迟参数
 */
var cookie_1 = __importDefault(require("../cookie"));
/**
 * 获取延迟参数
 */
function getDelayparams() {
    var delayparams = 'UID|ZUZHI|MOBILE|0|web';
    if (cookie_1.default.get('uidal')) {
        delayparams = delayparams.replace('UID', cookie_1.default.get('uidal').substring(0, 16));
    }
    else {
        delayparams = delayparams.replace('UID', '');
    }
    if (cookie_1.default.get('mtp') != null) {
        if (cookie_1.default.get('mtp') == '0') {
            delayparams = delayparams.replace('MOBILE', '3');
        }
        else {
            delayparams = delayparams.replace('MOBILE', cookie_1.default.get('mtp'));
        }
    }
    else {
        delayparams = delayparams.replace('MOBILE', '0');
    }
    if (cookie_1.default.get('wbp2uorgt') != null) {
        delayparams = delayparams.replace('ZUZHI', cookie_1.default.get('wbp2uorgt'));
    }
    else {
        delayparams = delayparams.replace('ZUZHI', '0');
    }
    return delayparams;
}
exports.getDelayparams = getDelayparams;
